module.exports = __webpack_public_path__ + "img/bg_feature_m.9ee157a9.svg";